import axios from "axios";
import { Base_URL } from "../url";

// Get all stages
export const fetchStages = async () => {
  try {
    const response = await axios.get(`${Base_URL}/StageMaster/GetAllStages`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching stages!";
  }
};

// Get stages by organization
export const fetchStagesByOrg = async (orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/StageMaster/GetStagesByOrg/${orgId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching stages by organization!";
  }
};

// Get stages by project
export const fetchStagesByProject = async (projectId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/StageMaster/GetStagesByProject/${projectId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching stages by project!";
  }
};

// Get stage by ID
export const fetchStageDetails = async (stageId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/StageMaster/GetStageById/${stageId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching stage details!";
  }
};

// Create new stage
export const createStage = async (stageData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/StageMaster/CreateStage`,
      stageData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error creating stage!";
  }
};

// Update stage
export const updateStage = async (stageId, stageData) => {
  try {
    const response = await axios.put(
      `${Base_URL}/StageMaster/UpdateStage/${stageId}`,
      stageData
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error updating stage!";
  }
};

// Delete stage
export const deleteStage = async (stageId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/StageMaster/DeleteStage/${stageId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error deleting stage!";
  }
};

// Delete stages by project
export const deleteStagesByProject = async (projectId) => {
  try {
    const response = await axios.delete(
      `${Base_URL}/StageMaster/DeleteStagesByProject/${projectId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error deleting stages by project!";
  }
};
